import axios, { AxiosPromise, AxiosResponse } from "axios";
import Storage from "../util/Storage";

const OnlineMenusApi = {
  getStats(locationId: number): AxiosPromise<AxiosResponse> {
    return axios.get(
      `/app/online/location/stats/${locationId}?oo=true`,
      {
        headers: {
          Authorization: "Bearer " + Storage.getToken(),
        },
      }
    );
  },
};

export default OnlineMenusApi;
